<template>
<div class="bg">
  <div class="minH100">
    <header>
      <div class="auto1200">
        <div class="logo-text">
          <img src="@/assets/images/logo.png" alt="">
          <h2>财经</h2>
        </div>
        <a href="http://www.gw.com.cn" target="_blank">首页</a>
      </div>
    </header>
    <div class="main">
      <div class="fl" v-if="videoList.length > 0">
        <div class="video-wrap">
          <video :src="videoList[curIndex].videourl" :poster="videoList[curIndex].imgurl" controls="controls" autoplay ref="video" width="910px" height="528px" v-if="videoList[curIndex].videourl.indexOf('video1.jsp?') < 0"></video>
          <div class="embed-box" v-else ref="embedbox">
            <embed :src="videoList[curIndex].videourl" width="620px" height="528px">
          </div>
        </div>
        <div class="video-info">
          <div class="fl">
            <h3>{{ videoTitle }}</h3>
            <!-- <time>{{ videoTime | formatDate }}</time> -->
          </div>
          <div class="fr">
            <span>{{ eyeData[curIndex] }}</span>
            <p>温馨提示：IE9以下浏览器不支持视频播放</p>
          </div>
        </div>
      </div>
      <div class="fr">
        <!-- <div>
          <h3>{{ videoTitle }}</h3>
          <time>{{ videoTime | formatDate }}</time>
        </div> -->
        <div class="list">
          <ul>
            <li v-for="(item, index) in videoList" :key="item.key" @click="changeUrl(index)" :class="{cur: curIndex === index}">
              <p>{{ item.title }}</p>
              <!-- <time>{{ item.begintime | formatDate }}</time> -->
            </li>
          </ul>
        </div>

      </div>
    </div>
    <div class="tips">
      <span>信息网络传播视听节目许可证 编号:0910546</span>
      <span>广播电视节目制作经营许可证 编号:(沪)字第00407号</span>
      <span>股市有风险 投资需谨慎</span>
    </div>
  </div>
  <footer>
    <div>
      <div class="footer-l">
        <span>
          <img src="@/assets/images/logo2.png" alt="">
          <strong>产品</strong>
        </span>
        <p><em>详情咨询</em>021-20219999</p>
      </div>
      <div class="footer-r">
        <a href="https://pay.dzh.com.cn/pay-mall/product/116" target="_blank">
          <span>365</span>
          <em>入门级</em>
        </a>
        <a href="https://pay.dzh.com.cn/pay-mall/product/73" target="_blank">
          <span>专业版</span>
          <em>进阶级</em>
        </a>
        <a href="https://pay.dzh.com.cn/pay-mall/product/126" target="_blank">
          <span>财富版</span>
          <em>精通级</em>
        </a>
        <a href="https://pay.dzh.com.cn/pay-mall/product/113" target="_blank">
          <span>策略版</span>
          <em>大师级</em>
        </a>
      </div>
    </div>
  </footer>
</div>
</template>

<script>
export default {
  data () {
    return {
      videoList: [],
      videoTitle: '',
      videoTime: '',
      curIndex: 0,
      eyeData: []
    }
  },
  mounted: function () {
    this.getVideo()
  },
  methods: {
    sortDate: function (attr) {
      return function (a, b) {
        var value1 = a[attr]
        var value2 = b[attr]
        return value2 > value1 ? 1 : -1
      }
    },
    getVideo: function () {
      var _this = this
      this.$ajax.getVideo()
        .then(function ({ data }) {
          if (typeof (data) === 'string') {
            data = JSON.parse(data)
          }
          var res = data[0].data
          var lessonData = []
          var videoData = []
          for (var i = 0; i < res.length; i++) {
            if (res[i].lessons[0]) {
              lessonData.push(res[i].lessons)
            }
          }
          for (var a = 0; a < lessonData.length; a++) {
            for (var b = 0; b < lessonData[a].length; b++) {
              videoData.push(lessonData[a][b])
            }
          }
          _this.videoList = videoData.sort(_this.$options.methods.sortDate('begintime'))
          _this.videoTitle = _this.videoList[0].title
          _this.videoTime = _this.videoList[0].begintime
          for (var c = 0; c < _this.videoList.length; c++) {
            _this.eyeData.push(parseInt(_this.videoList[c].id))
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    changeUrl: function (index) {
      this.curIndex = index
      this.videoTitle = this.videoList[index].title
      this.videoTime = this.videoList[index].begintime
      this.$set(this.eyeData, index, this.eyeData[index] + 1)
      var embed = `<embed src="${this.videoList[this.curIndex].videourl}" width="620px" height="528px">`
      if (this.$refs.embedbox) {
        this.$refs.embedbox.getElementsByTagName('embed')[0].style.display = 'none'
        this.$refs.embedbox.innerHTML = ''
        this.$refs.embedbox.innerHTML = embed
      }
    }
  },
  filters: {
    formatDate: function (value) {
      if (!value) return ''
      return value.slice(0, 10)
    }
  }
}
</script>

<style lang="scss" scoped>
body,html{
  height: 100%;
}
.bg{
  background: url(../../../public/images/bg.jpg) center 93px no-repeat #000;
  width: 100%;
}
.minH100{
  min-height: 100vh;
  padding-bottom: 150px;
}
.auto1200{
  @include auto(1200px);
}
header{
  @include wh(100%,93px);
  background: #001841;
  .auto1200{
    height: 93px;
  }
  .logo-text{
    @include line-height(93px);
    float: left;
    img{
      display: inline-block;
      vertical-align: middle;
      margin-top: -27px;
    }
    h2{
      display: inline-block;
      @include fc(34px, #00a0e9);
      font-weight: bolder;
      &:before{
        content: '';
        display: inline-block;
        @include wh(2px, 31px);
        margin: 0 20px;
        vertical-align: middle;
        background: #00a0e9;
        margin-top: -5px;
      }
    }
  }
  a{
    @include fc(24px, #b3b3b3);
    background: url(../../assets/images/home.png) no-repeat;
    padding-left: 45px;
    float: right;
    margin-top: 30px;
    &:hover{
      color: #00a0e9;
    }
  }
}
.main{
  overflow: hidden;
  @include auto(1200px);
  margin: 21px auto 70px;
  background: #0e0e0e;
  .fl{
    h3{
      @include fc(24px, #e6e6e6);
    }
    time{
    @include fc(18px, #9a9a9a);
    margin: 12px 0 15px;
    display: block;
    }
    .video-wrap{
      width: 910px;
      height: 528px;
      background: #1a1a1a;
      video{
        width: 100%;
        outline: 0;
        object-fit:fill;
      }
      .embed-box{
        width: 620px;
        margin: 0 auto;
        display: block;
        padding: 0;
        background: #1a1a1a;
      }
    }
    .video-info{
      background: #0e0e0e;
      padding: 20px 20px 3px;
      height: 105px;
      h3{
        @include fc(24px, #00afff);
      }
      time{
        @include fc(24px, #808080);
      }
      span{
        @include fc(14px, #00afff);
        display: block;
        margin: 8px 0 20px;
        text-align: right;
        background: url(../../assets/images/eye.png) no-repeat 200px center;
        line-height: 24px;
      }
      p{
        @include fc(14px, #808080);
        text-align: right;
      }
    }
  }
  .fr{
    width: 280px;
    >div{
      &:nth-of-type(1){
        background: #0e0e0e;
        padding: 13px;
        border-top: 1px solid #323232;
        h3{
          @include fc(16px, #fff);
          @include text-overflow;
          margin-bottom: 10px;
        }
        time{
          @include fc(16px, #fff);
        }
      }
    }
    .list{
      width: 280px;
      height: 622px;
      overflow-y: scroll;
      background: #1f1f1f;
      @include scrollbar;
      ul{
        li{
          @include fc(16px, #b1b1b1);
          display: block;
          position: relative;
          background: #323232;
          padding: 15px 15px 12px;
          border-bottom: 1px solid #000000;
          cursor: pointer;
          p{
            line-height: 25px;
            margin-bottom: 5px;
          }
          time{
            @include fc(14px, #808080);
          }
          &.cur{
            color: #00afff;
            background: #1f1f1f;
            p{
              font-size: 20px;
            }
          }
          &:hover{
            color: #00afff;
            time{
              color: #00afff;
            }
          }
        }
      }
    }

  }
}
.tips{
  @include auto(1200px);
  overflow: hidden;
  padding-bottom: 20px;
  span{
    @include fc(16px, #4d4d4d);
    &:nth-child(1){
      float: left;
    }
    &:nth-child(2){
      float: left;
      margin-left: 60px;
    }
    &:nth-child(3){
      float: right;
    }
  }
}
footer{
  background: #1a1a1a;
  padding:28px 0px;
  height: 150px;
  margin-top: -150px;
  border-top: 1px solid #4d4d4d;
  >div{
    @include auto(1200px);
  }
  .footer-l{
    float: left;
    img{
      display: inline-block;
      vertical-align: bottom;
    }
    strong{
      @include fc(26px, #7f7f7f);
      &:before{
        content: '';
        display: inline-block;
        width: 2px;
        height: 24px;
        margin: 0px 12px 0 10px;
        background: #595959;
        vertical-align: middle;

      }
    }
    p{
      margin-top: 20px;
      @include fc(16px, #969696);
      em{
        margin-right: 14px;
      }
    }
  }
  .footer-r{
    margin-left: 265px;
    letter-spacing: 0.5px;
    a{
      display: inline-block;
      position: relative;
      +a{
        margin-left: 60px;
      }
    }
    span{
      @include fc(30px, #e4e4e4);
      line-height: 1;
      margin-right: 8px;
    }
    em{
      @include fc(12px, #000000);
      background: url(../../assets/images/bg-tag-hover.png) no-repeat;
      display: inline-block;
      @include vertical-center(48px,18px);
      vertical-align: top;
      text-indent: 4px;
      margin-top: 4px;
    }
  }
}
</style>
